<template>
  <div class="calendar-layout">
    <router-view />
  </div>
</template>

<script>

  export default {
    name: 'CalendarLayout'
  }
</script>

<style scoped>
.calendar-layout {
  height:100%;
  color: #000;
  font-size: 14px;
}
</style>
